<template>

    <div class="hero">
        <div class="title_notice_line">
            <div class="coeffs_heading container">
                <h1 class="page-title title is-size-2 has-text-weight-bold">Evaluation de l'équipe</h1>
                <!-- <notifText v-html="$t('modules.refs.formStep4.globalNotice')" /> -->
                <div  class="notification_text is-default">Veuillez trouver ci dessous le score moyen de l'équipe en orange, le référentiel saven en vert et la recommandation de notre algorithme en bleu.</div>
            </div>
        </div>
        <div class="hero-body team_fit_form_wrapper">
            
            <div class=" bottom-section container">
                <!-- <div class="model_align_btn small_margin" @click="syncScores" >
                    <span>{{ $t('modules.refs.formStep4.SyncRefButton') }}</span>
                    <div class="btn_tick">
                        <div class="btn_inner_tick"></div>
                    </div>
                </div> -->
                <div class="has-text-centered">
                    <button class="button  is-info is-rounded is-outlined" @click="saveRef()">
                        {{ $t('modules.positions.teamFit.validateScores') }}
                    </button>
                </div>
                <div class="columns">
                    <div class="column">
                        <div class="scores_columns_container">
                            <div v-for="( scoreKey, index ) in firstScoresMap">
                                <h3 class="dim_cat_title ref_score_cat_title" v-if="index == 0">
                                    {{ $t('dimensions.skills_titles.title1') }}
                                </h3>
                                <h3 class="dim_cat_title ref_score_cat_title" v-if="index == 2">
                                    {{ $t('dimensions.skills_titles.title3') }}
                                </h3>

                                <SkillScoreRadios
                                    :score-id="scoreKey"
                                    :score='teamRef.sight3_scores[scoreKey]'
                                    :ref-score="currentRef.sight3_scores[scoreKey]"
                                    :moy-score="moyScores[scoreKey]"
                                    :friendRef1="null"
                                    :friendRef2="null"
                                    @change="syncVal" />
                            </div>
                        </div>

                    </div>
                    <div class="column">
                        <div class="scores_columns_container">

                            <div v-for="( scoreKey, index ) in middleScoresMap">
                                <h3 class="dim_cat_title ref_score_cat_title" v-if="index == 0">
                                    {{ $t('dimensions.skills_titles.title4') }} 
                                </h3>
                                
                                <SkillScoreRadios
                                    :score-id="scoreKey"
                                    :score='teamRef.sight3_scores[scoreKey]'
                                    :ref-score="currentRef.sight3_scores[scoreKey]"
                                    :moy-score="moyScores[scoreKey]"
                                    :friendRef1="null"
                                    :friendRef2="null"
                                    @change="syncVal" />
                            </div>
                        </div>

                    </div>
                    <div class="column">
                        <div class="scores_columns_container">
                            <div v-for="( scoreKey, index ) in lastScoresMap">

                                <h3 class="dim_cat_title ref_score_cat_title" v-if="index == 0">
                                    {{ $t('dimensions.skills_titles.title2') }}
                                </h3>
                                
                                <SkillScoreRadios
                                    :score-id="scoreKey"
                                    :score='teamRef.sight3_scores[scoreKey]'
                                    :ref-score="currentRef.sight3_scores[scoreKey]"
                                    :moy-score="moyScores[scoreKey]"
                                    :friendRef1="null"
                                    :friendRef2="null"
                                    @change="syncVal" />
                            </div>
                        </div>

                    </div>
                </div>
                
            </div>

        </div>
    </div>

</template>

<script>
    export default {
        name: 'TeamFitRefForm',
        props: ['evaluations', 'currentRef'],
        components: {},
        created(){
            this.teamRef = JSON.parse(JSON.stringify(this.currentRef))
            this.teamRef.associated_ref_id = this.currentRef.id
            this.teamRefBase = JSON.parse(JSON.stringify(this.currentRef))
            this.createRefScores()
            this.copyBaseRefScore()
        },
        data(){
            return {
                firstScoresMap: ["r1", "r2", "r8", "r9"],
                middleScoresMap: ["r10", "r11", "r12", "r13", "r14", "r15", "r16", "r17"],
                lastScoresMap: ["r3", "r4", "r5", "r6", "r7"],
                teamRef: {},
                teamRefBase: {},
                moyScores: {"r1": 0, "r2": 0, "r3": 0, "r4": 0, "r5": 0, "r6": 0, "r7": 0, "r8": 0, "r9": 0, "r10": 0, "r11": 0, "r12": 0, "r13": 0, "r14": 0, "r15": 0, "r16": 0, "r17": 0},
                dims: {"r1": 0, "r2": 0, "r3": 0, "r4": 0, "r5": 0, "r6": 0, "r7": 0, "r8": 0, "r9": 0, "r10": 0, "r11": 0, "r12": 0, "r13": 0, "r14": 0, "r15": 0, "r16": 0, "r17": 0}
            }
        },
        computed: {
        },
        methods: {
            createRefScores(){
                const dimArray = ["r1", "r2", "r3", "r4", "r5", "r6", "r7", "r8", "r9", "r10", "r11", "r12", "r13", "r14", "r15", "r16", "r17"]
                dimArray.forEach((dim, index) => {
                    this.dims[dim] = this.hashScores(index, dim)
                })
            },
            copyBaseRefScore(){
                this.teamRef.sight3_scores = JSON.parse(JSON.stringify(this.dims))
                this.teamRef.id = null
                this.teamRef.name = ""
                this.teamRef.ref_type = "custom"
                this.teamRefBase.sight3_scores = JSON.parse(JSON.stringify(this.dims))
            },
            hashScores(index, dim){
                let score = 0
                let final_score = 0
                this.evaluations.forEach((eva) => {
                    if(eva.completed){
                        this.currentRef.sight3_scores[dim]
                        score = score + eva.saven_test.soft_skills_data[index].base_score
                    }
                })
                let moy = parseInt((score / this.evaluations.length).toFixed(0))
                this.moyScores[dim] = moy
                // console.log(this.currentRef.sight3_scores[dim], moy)
                // console.log(this.currentRef.sight3_scores[dim] == moy)
                if(this.currentRef.sight3_scores[dim] == moy){
                    return moy
                }else{
                    if(this.currentRef.sight3_scores[dim] < moy){
                        return this.currentRef.sight3_scores[dim]
                    }else{
                        let testScore = this.currentRef.sight3_scores[dim] + (this.currentRef.sight3_scores[dim] - moy)
                        console.log(testScore, moy, this.currentRef.sight3_scores[dim])
                        if(testScore < 5){
                            return testScore
                        }else{
                            return 5
                        }
                    }
                }
            },
            syncVal(scoreData){
                this.teamRef.sight3_scores[scoreData.id] = scoreData.val
            },
            saveRef(){
                this.$emit('ScoreValidated', "title_ref_form", this.teamRef)


            }
        }
    }
</script>

<style lang="scss" scoped>
.team_fit_form_wrapper{
    background: white;
}
</style>
